<p-accordionTab>
    <p-header>
      <div class="ui-helper-clearfix">
        <div class="left">
          <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Preserve Device Special Logical State(AT+GTPDS)</span>
        </div>
      </div>
    </p-header>
  
    <div class="ui-g">
      <div class="ui-g">
        <p-accordionTab [selected]="true">
          <p-header>
            <div class="ui-helper-clearfix">
              <div class="left">
                <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Main
                  Settings</span>
              </div>
            </div>
          </p-header>
          <div class="col row dvcFields">
            <div class="col lblStyle">
              <form-input fieldName="Mode">
              </form-input>
            </div>
            <div class="col">
              <div class="ui-inputgroup">
                <p-dropdown [options]="modeOptions" [(ngModel)]="pdsParameters.mode"
                  [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </div>
      <div class="ui-g">
        <p-accordionTab [selected]="true">
          <p-header>
            <div class="ui-helper-clearfix">
              <div class="left">
                <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Mask
                  Settings</span>
              </div>
            </div>

          </p-header>
          <div class="row align-items-center">
            <div class="col row dvcFields">
                <div class="col">
                    <p-checkbox binary="true" label="States of Geo" [(ngModel)]="pdsParameters.stateOfGeo">
                    </p-checkbox>
                </div>
            </div>       
          </div>
          <div class="row align-items-center">
            <div class="col row dvcFields">
                <div class="col">
                    <p-checkbox binary="true" label="Information of last known position" [(ngModel)]="pdsParameters.lastKnownPosition">
                    </p-checkbox>
                </div>
            </div>       
          </div>
          <div class="row align-items-center">
            <div class="col row dvcFields">
                <div class="col">
                    <p-checkbox binary="true" label="States of ignition" [(ngModel)]="pdsParameters.stateIgnition">
                    </p-checkbox>
                </div>
            </div>       
          </div>
          <div class="row align-items-center">
            <div class="col row dvcFields">
                <div class="col">
                    <p-checkbox binary="true" label="States of SSR" [(ngModel)]="pdsParameters.stateSSR">
                    </p-checkbox>
                </div>
            </div>       
          </div>
          <div class="row align-items-center">
            <div class="col row dvcFields">
                <div class="col">
                    <p-checkbox binary="true" label="States of main power" [(ngModel)]="pdsParameters.stateMainPower">
                    </p-checkbox>
                </div>
            </div>       
          </div>
          <div class="row align-items-center">
            <div class="col row dvcFields">
                <div class="col">
                    <p-checkbox binary="true" label="States of PEO" [(ngModel)]="pdsParameters.statePEO">
                    </p-checkbox>
                </div>
            </div>       
          </div>
 
        </p-accordionTab>
      </div>
    </div>
  </p-accordionTab>